import Route, { ROUTE_COLOR_DANGER } from "@rio-cloud/rio-uikit/Route";
import { getRandomValueToForceRerender } from "../functions/getRandomValueToForceRerender";
import { IRouteSegment } from "../interfaces/IRouteSegment";

interface SegmentsProps {
  segments: IRouteSegment[];
  enableAutonomy?: boolean;
  expanded?: boolean;
}

export const Segments = ({ segments, enableAutonomy = false, expanded = false }: SegmentsProps) => {
  const shouldUseRedColor = enableAutonomy && expanded;

  const mapSegments = segments.map((segment) => {
    return (
      <Route
        key={getRandomValueToForceRerender()}
        positions={segment.points}
        isRouteAlternative={segment.alternative}
        hasArrows={segment.showArrows}
        style={segment?.suggestedColor ? { color: segment.suggestedColor } : shouldUseRedColor || segment.alternative ? { color: ROUTE_COLOR_DANGER } : undefined}
      />
    );
  });
  return <>{mapSegments}</>;
};
